module.exports = __webpack_public_path__ + "fonts/Inter-600-cyrillic-ext39.47734ae.woff2";